<template>
  <div>
    <div class="page-actions">
      <create @refresh="getProjectList"></create>
      <el-button icon="el-icon-delete" @click="remove()" type="danger"
        >删除数据</el-button
      >
      <el-button icon="el-icon-time" @click="startfen()" type="success"
        >开始分红</el-button
      >
      <el-button icon="el-icon-switch-button" @click="stopfen()" type="primary"
        >停止分红</el-button
      >
    </div>
    <el-table :data="projectList">
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="coinType" label="币种"> </el-table-column>
      <el-table-column prop="amount" label="分红数量"> </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip content="查看">
            <el-button
              type="info"
              size="small"
              circle
              icon="el-icon-edit"
              @click="viewDetail(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-button
            @click="oneSend(scope.row.userId)"
            size="small"
            type="primary"
            >分红</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';
import Create from '../create';

export default {
  name: 'userdividend',
  computed: {
    ...mapState('userdividend', ['totalCount', 'pagination']),
    ...mapGetters('userdividend', ['projectList'])
  },
  components: {
    Pagination,
    Detail,
    Create
  },
  methods: {
    ...mapMutations('userdividend', ['setEditingProject']),
    ...mapActions('userdividend', [
      'deletes',
      'toair',
      'getCoinTypeList',
      'getList',
      'startDivident',
      'endDivident',
      'Onestart'
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...this.pagination,
        ...data
      });
    },
    viewDetail(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    remove() {
      this.deletes().then(() => {
        this.$message({
          message: '删除成功！',
          type: 'success'
        });
        this.$emit('refresh', this.pagination);
      });
    },
    startfen() {
      this.startDivident().then(() => {
        this.$message({
          message: '分红开始',
          type: 'success'
        });
      });
    },
    stopfen() {
      this.endDivident().then(() => {
        this.$message({
          message: '已停止分红',
          type: 'success'
        });
      });
    },
    oneSend(id) {
      this.Onestart({ userId: id }).then(() => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.$emit('refresh', this.pagination);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
